import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AUTHORIZATION_TYPE_ENUM } from '../lists/authorization-types';
import { RO_STATES } from '../lists/ro-states';

export type RoStateGroup ="budget" | "opened" | "closed" | "ended" | "rejected" | "started" | "closed-budget" ;

/**
 * Etapas granulares do ciclo de vida da OS (capability `os-lifecycle-stages`), derivadas de
 * `currentState`/`authorizationType`. `faturada` e `rejeitada` partilham `currentState` 10 e são
 * distinguidas apenas por `authorizationType`.
 */
export type OsStageId =
  | "orcamento"
  | "autorizacao"
  | "agendada"
  | "aberta"
  | "fechada"
  | "faturada"
  | "rejeitada"
  | "orcamento-fechado";

export type RoListStateGroup = RoStateGroup | "all" | "integrated_opened" | OsStageId;

/**
 * OS rejeitada: mesmo `currentState` (10, FINISHED) de uma OS faturada, distinta só por
 * `authorizationType` — a única forma de saber que o orçamento foi recusado pelo cliente
 * (capability `os-lifecycle-stages`; ver `os-stage-count-service.ts` no apimekanicgo,
 * `stageForRow`). Ponto único desta regra no front: reaproveitada por `os-panel.component.ts`
 * (`_normalizeRows`, sobre linhas cruas de `PaginatedOS`) e por `app-os-detail-header`
 * (`os-detail-header.util.ts`, sobre um `MkgOS` já carregado).
 */
export function isRejectedOs(ro: { currentState: number; authorizationType?: number }): boolean {
  return ro.currentState === RO_STATES.rejected
    || (ro.currentState === RO_STATES.finished && ro.authorizationType === AUTHORIZATION_TYPE_ENUM.REJECTED);
}

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'roStateGroup'
})
export class RoStateGroupPipe implements PipeTransform {
  transform(value: number, withStarted = false): RoStateGroup {
    switch (value) {
      case RO_STATES.budget: // 2
      case RO_STATES.authorization: // 4
      case RO_STATES.appointment: // 5
      case RO_STATES.readyToStart: // 6
        return 'budget';

      case RO_STATES.started: // 7
        return 'opened';

      case RO_STATES.toReceive: // 8
      case RO_STATES.evaluation: // 9
        return 'closed';

      case RO_STATES.finished: // 10
        return 'ended';

      case RO_STATES.rejected: // 11
        return 'rejected';
      case RO_STATES.closedBudget: // 13
        return 'closed-budget'
      default:
        return "ended";
    }
  }
}
